import { render, staticRenderFns } from "./classeDiscipline.vue?vue&type=template&id=2dbc323f&"
import script from "./classeDiscipline.vue?vue&type=script&lang=js&"
export * from "./classeDiscipline.vue?vue&type=script&lang=js&"
import style0 from "./classeDiscipline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports